import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import { hydrate } from 'react-dom';
import configureStore from './store';
import { GlobalProvider } from './context/globalContext';
import { ensureReady, After, getSerializedData } from '@jaredpalmer/after';
import { Provider } from 'react-redux';
import routes from './routes';

const preloadedState = getSerializedData('preloaded_state');
const store = configureStore(preloadedState);

function renderApp() {
  ensureReady(routes).then(data =>
    hydrate(
      <Provider store={store}>
        <BrowserRouter>
          <GlobalProvider>
            <After data={data} routes={routes} store={store} />
          </GlobalProvider>
        </BrowserRouter>
      </Provider>,
      document.getElementById('root')
      )
  );
}

renderApp();

if (module.hot) {
  module.hot.accept('./routes', renderApp);
}